/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Box } from '@nexigendigital/nxui'

import PromoForm from 'containers/shop/cart/form/promoForm'
import CartSummary from 'containers/shop/cart/cartSummary'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function OrderTotal () {
    return (
        <Box header={{ title: 'Order Total' }}>
            <StyledOrderTotal>
                <PromoForm/>
                <CartSummary/>
            </StyledOrderTotal>
        </Box>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
export const StyledOrderTotal = styled.section`
    width: 100%;
    
    > div > form {
        padding: 20px 24px 0 20px;
        border-top: 1px solid ${props => props.theme['gray--100']};
    }
    
    > div {
        > div:first-child {
            border: none;
            border-radius: 0;
        }
        
        > div:nth-child(2) {
            border: none;
            border-radius: 0;
            box-shadow: none;
        }
    }
`
